import React from 'react';
import { IconProps } from '.';

const SvgBoxCanada = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#fff'
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill='#D52B1E'
        d='M2.417 5.333a2.5 2.5 0 0 1 2.5-2.5h.833v18.334h-.833a2.5 2.5 0 0 1-2.5-2.5V5.333ZM21.583 5.333a2.5 2.5 0 0 0-2.5-2.5h-.833v18.334h.833a2.5 2.5 0 0 0 2.5-2.5V5.333ZM12.304 14.523l2.395.256-.21-.639a.28.28 0 0 1 .11-.303L17 12.03l-.497-.216c-.219-.072-.159-.186-.08-.46l.367-1.234-1.395.272c-.136.02-.227-.06-.247-.137l-.18-.58-1.104 1.143c-.156.184-.474.184-.375-.24l.471-2.316-.633.303c-.177.092-.355.107-.453-.057L12 7l-.873 1.508c-.1.164-.277.149-.454.057l-.633-.303.472 2.316c.1.424-.219.424-.376.24L9.033 9.675l-.18.58c-.02.077-.111.157-.247.138L7.21 10.12l.366 1.234c.078.274.139.388-.08.46L7 12.03l2.402 1.806a.279.279 0 0 1 .109.304l-.21.638 2.395-.255c.073 0 .121.037.12.115L11.67 17h.66l-.147-2.36c.001-.08.049-.117.122-.117Z'
      />
      <path
        fill='#E0E0E4'
        fillRule='evenodd'
        d='M18.667 3.25H5.333c-1.15 0-2.083.933-2.083 2.083v13.334c0 1.15.933 2.083 2.083 2.083h13.334c1.15 0 2.083-.933 2.083-2.083V5.333c0-1.15-.933-2.083-2.083-2.083ZM5.333 2A3.333 3.333 0 0 0 2 5.333v13.334A3.333 3.333 0 0 0 5.333 22h13.334A3.333 3.333 0 0 0 22 18.667V5.333A3.333 3.333 0 0 0 18.667 2H5.333Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBoxCanada;
